export const hamburgerButtonConfig = {
  numLines: 2,
  lineSize: 16, // px
  lineThickness: 2, // px
  lineSpacing: 6, // px
  animateClockwise: false, // which way the outer lines rotate to form a cross
  animationDuration: 225, // milliseconds
};
